import React, { useState } from 'react';
import { Search, X, ChevronRight } from 'lucide-react';
import { useLang } from '../../core/lang.jsx';
import LangKeys from '../../core/locales/keys';

const UNITS = [
  "AMP (Ampoule)", "BCK (Buckets)", "BDL (Bundles)", "BKL (Buckles)", "BOR (Bora)",
  "BOU (Billion of Units)", "BOX (Box)", "BTL (Bottles)", "BUN (Bunches)", "CAN (Cans)",
  "CASE (CASE)", "CBM (Cubic Meters)", "CCM (Cubic Centimeters)", "CMS (Centimeters)",
  "COIL (Coil)", "CPS (Capsules)", "CTN (Cartons)", "CTS (Carats)", "CUFT (Cubic Feet)",
  "DAY (Days)", "DOZ (Dozens)", "DRM (Drums)", "FT (Feet)", "GGK (Great Gross)",
  "GLS (Glasses)", "GMS (Grammes)", "GRS (Gross)", "GYD (Gross Yards)", "HRS (Hours)",
  "IN (Inches)", "JAR (Jars)", "KG (Kilograms)", "KLR (Kilolitre)", "KME (Kilometre)",
  "KW (Kilowatt)", "LENG (Length)", "LTR (Litre)",
  "MAN-DAY (Man Days)", "MINS (Minutes)",
  "MLG (Milligram)", "MLT (Mililitre)", "MM (Millimeter)", "MT (Metric Ton)", "MTR (Meters)",
  "NIGHT (Nights)", "NOS (Numbers)", "OTH (Others)", "PAC (Packs)", "PCS (Pieces)",
  "PET (Peti)", "PKT (Packets)", "PLT (Plates)", "POCH (Pouch)", "PRS (Pairs)",
  "PRT (Portion)", "QTL (Quintal)", "QTY (Quantity)", "RFT (Running Feet)", "RMT (Running Meter)",
  "ROL (Rolls)", "SAC (Sachet)", "SET (Sets)", "SQCM (Square Centimeters)", "SQF (Square Feet)",
  "SQIN (Square Inches)", "SQM (Square Yards)", "SQMT (Square Meters)", "STRP (Strips)",
  "TBS (Tablets)", "TGM (Ten Gross)", "THD (Thousands)", "TKT (Ticket)", "TON (Tonnes)",
  "TRY (Trays)", "TUB (Tubes)", "UGS (US gallons)", "UNT (Units)", "W (Watt)", "YDS (Yards)"
];

const UnitPickerModal = ({ isOpen, onClose, onSelect }) => {
  const { t } = useLang();
  const [search, setSearch] = useState('');

  if (!isOpen) return null;

  const filtered = UNITS.filter(u => u.toLowerCase().includes(search.toLowerCase()));

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <div style={styles.header}>
          <h3 style={styles.title}>{t(LangKeys.select_unit)}</h3>
          <button style={styles.closeBtn} onClick={onClose}><X size={20} /></button>
        </div>
        
        <div style={styles.searchBox}>
          <Search size={18} color="#94A3B8" />
          <input 
            autoFocus
            style={styles.searchInput} 
            placeholder={t(LangKeys.search_unit)} 
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        <div style={styles.list}>
          {filtered.map(unit => (
            <div key={unit} style={styles.item} onClick={() => { onSelect(unit.split(' ')[0]); onClose(); }}>
              <span style={styles.itemText}>{unit}</span>
              <ChevronRight size={16} color="#E2E8F0" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: { position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000 },
  modal: { width: '400px', backgroundColor: '#FFF', borderRadius: '24px', display: 'flex', flexDirection: 'column', maxHeight: '80vh', overflow: 'hidden' },
  header: { padding: '20px', borderBottom: '1px solid #F1F5F9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  title: { fontSize: '18px', fontWeight: '800', color: '#1D4ED8', margin: 0 },
  closeBtn: { border: 'none', background: 'none', color: '#64748B', cursor: 'pointer' },
  searchBox: { margin: '16px', padding: '0 12px', height: '44px', backgroundColor: '#F8FAFC', borderRadius: '12px', border: '1px solid #E2E8F0', display: 'flex', alignItems: 'center', gap: '8px' },
  searchInput: { border: 'none', outline: 'none', backgroundColor: 'transparent', flex: 1, fontSize: '14px', fontWeight: '600' },
  list: { flex: 1, overflowY: 'auto', padding: '0 8px 16px 8px' },
  item: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 12px', borderRadius: '12px', cursor: 'pointer', transition: 'background 0.2s' },
  itemText: { fontSize: '14px', fontWeight: '600', color: '#1E293B' },
};

export default UnitPickerModal;
